import React, { useState} from "react";
import { useNavigate } from "react-router-dom";
import {LoadingSpinner} from '../loadingSpinner/LoadingSpinner'
import { useIntl } from 'react-intl';
import { callApi } from "../auth/ApiService";
import common from "../config/common.json";
import icon from "../config/icon.json"
import "./ChildResetPassword.css"


function ChildResetPassword() {
  const intl = useIntl();
  const [timerOn, setTimerOn] = useState(false);
  const [hide, setHide] = useState(false);
  const [remainingSecond, setRemainingSecond] = useState('30');
  const [number, setNumber] = useState("Verification code sent to your phone number");
  const [verifiction, setVerifiction] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [ passwordWarning, setPasswordWarning ] = useState({
    warningUpperCase: false,
    warningLowerCase: false,
    warningNumber: false,
    warningLength: false,
    warningSpecialChar: false
  });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  


  function restetOtpConfirmPassword() {
    if (verifiction !== "" && newPassword !== "" && confirmPassword !== "") {
      if(isPasswordValid()){
        if (newPassword === confirmPassword) {        
          updatePassword();
        } else {
          setError(intl.formatMessage({ id: 'passowordAndConfirmPasswordError' }));
        }
      }
    }else{
      setError(intl.formatMessage({ id: 'mustProvideAllDetalis' }));
    }
  }

  const isPasswordValid = () => {
    if (passwordWarning.warningUpperCase && 
      passwordWarning.warningLowerCase &&
      passwordWarning.warningNumber &&
      passwordWarning.warningLength &&
      passwordWarning.warningSpecialChar){
        return true;
    }else{
      return false;
    }
  }

  const checkPasswordWarning = (passwordVal) => {
    let uppercase = passwordVal.match(/[A-Z]/g);
    if (uppercase == null) {
      setPasswordWarning((oldState) => ({ ...oldState, warningUpperCase: false}))
    }else{
      setPasswordWarning((oldState) => ({ ...oldState, warningUpperCase: true}))
    }

    let lowercase = passwordVal.match(/[a-z]/g);
    if (lowercase == null) {
      setPasswordWarning((oldState) => ({ ...oldState, warningLowerCase: false}))
    }else{
      setPasswordWarning((oldState) => ({ ...oldState, warningLowerCase: true}))
    }

    let one_number = passwordVal.match(/[0-9]/g);
    if (one_number == null) {
      setPasswordWarning((oldState) => ({ ...oldState, warningNumber: false}))
    }else{
      setPasswordWarning((oldState) => ({ ...oldState, warningNumber: true}))
    }

    let minimum_length = 12;
    if (passwordVal.length < minimum_length) {
      setPasswordWarning((oldState) => ({ ...oldState, warningLength: false}))
    }else{
      setPasswordWarning((oldState) => ({ ...oldState, warningLength: true}))
    }

    if (passwordVal.includes("@")) {
      setPasswordWarning((oldState) => ({ ...oldState, warningSpecialChar: false}))
    }else{
      setPasswordWarning((oldState) => ({ ...oldState, warningSpecialChar: true}))
    }
  }

  const hideShow = (id,imageId) => {
    var x = document.getElementById(id);
    if (x.type === "password") {
      x.type = "text";
      document.getElementById(imageId).src = `${icon.showIcon}`
    } else {
      x.type = "password";
      document.getElementById(imageId).src = `${icon.hideIcon}`
    }
  };


  async function updatePassword() {
    setIsLoading(true);
    if(isLoading){
      return 0;
    }
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var raw = JSON.stringify({
      username: localStorage.getItem("ForgetUser"),
      code: verifiction,
      password: newPassword,
      sipId: localStorage.getItem("sip_id")
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const result = await callApi(`${common.BASEURL}/confirmPassword`,requestOptions);
      setIsLoading(false);
      var data = JSON.parse(result.body);
      if (data.success) {
        navigate("/passwordchange");
      } else {
        setIsLoading(false);
        setError(data.msg);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }

  async function resendConfirmationCode() {
    if (timerOn){
      return 0;
    }
    setHide(false);
    setError("");
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var raw = JSON.stringify({
      username: localStorage.getItem("email"),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };


    try {
      await callApi(`${common.BASEURL}/resendConfirmationCode`,requestOptions);
      setTimerOn(true);
      setNumber(intl.formatMessage({ id: 'verificationSetYourNumber' }));
      timer(30);
    } catch (error) {
      console.log(error);
      setHide(true);
    }
  }

  function timer(remaining) {
    var isTimerOn = true;
    var s = remaining % 60;
    
    s = s < 10 ? '0' + s : s;
    setRemainingSecond(s)
    remaining -= 1;

    if(remaining >= 0 && isTimerOn) {
      setTimeout(function() {
          timer(remaining);
      }, 1000);
      return;
    }
  
    if(!isTimerOn) {
      return;
    }
    
    isTimerOn = false;
    setTimerOn(false);
  }

  function back() {
    navigate("/");
  }

  return (
    <div>
        <div className="reset_password_wrapper responsive_wrapper">
          <div className="main_logo_reat_password">
            <img src={`/assets/image/${common.ClientId}_logo.png`} className="logo" alt="img"/>
          </div>
          <div>
          <div className="hero_title">
            <h3 className="font_main_color light">Reset your password</h3>
          </div>
          <div className="error">{error}</div>
          <div className="success">{number}</div>
          <form onSubmit={(e) => {
              e.preventDefault();
              restetOtpConfirmPassword();
          }}>
            <label>
              <p className="font_main_color label_login">Verifiction code</p>
              <input
                className="input_edit"
                type="text"
                placeholder="Verifiction code"
                onChange={(e) => {
                  setVerifiction(e.target.value);
                  setError("");
                  setNumber("");
                }}
                maxLength="6"
                required
              />
            </label>
            <label>
              <p className="font_main_color label_login">New password</p>
              <input
                className="input_edit"
                placeholder="New password"
                type="password"
                id={intl.formatMessage({ id: 'newPassword' })}
                maxLength="18"
                onChange={(e) => {
                  setNewPassword(e.target.value);
                  checkPasswordWarning(e.target.value);
                  setNumber("");
                }}
                required
              />
              <i className="iconShow"><img
                      id="newPassword"
                      src={icon.hideIcon}
                      onClick={()=>{
                        hideShow(intl.formatMessage({ id: 'newPassword' }),"newPassword")
                      }}
                    /></i>                   
            </label>
            <div>
            {newPassword.length !== 0 && <div className={("password_warning_parents")}>
                      
                <span className= {passwordWarning.warningUpperCase?"passwordSuccess":"passwordError"} >{ passwordWarning.warningUpperCase ? "✓" : "✖"} {intl.formatMessage({ id: 'upperCasePasswordPolicyError' })}</span>
                <span className={passwordWarning.warningLowerCase?"passwordSuccess":"passwordError"}>{ passwordWarning.warningLowerCase ? "✓" : "✖"} {intl.formatMessage({ id: 'lowerCasePasswordPolicyError' })}</span>
                <span className={passwordWarning.warningNumber?"passwordSuccess":"passwordError"}>{ passwordWarning.warningNumber ? "✓" : "✖"} {intl.formatMessage({ id: 'passwordNumberPolicyError' })}</span>
                <span className={passwordWarning.warningLength?"passwordSuccess":"passwordError"}>{ passwordWarning.warningLength ? "✓" : "✖"} {intl.formatMessage({ id: 'passwordLengthPolicyError' })}</span>
                <span className={passwordWarning.warningSpecialChar?"passwordSuccess":"passwordError"}>{ passwordWarning.warningSpecialChar ? "✓" : "✖"} {intl.formatMessage({ id: 'password@PolicyError' })}</span>
              </div>}
              </div> 
            <label>
              <p className="font_main_color label_login">Confirm password</p>
              <input
                className="input_edit"
                placeholder="Confirm password"
                type="password"
                maxLength="18"
                id={intl.formatMessage({ id: 'confirmPassword' })}

                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  // checkPasswordWarning(e.target.value)
                }}
                required
              />
              <i className="iconShow"><img
                      id="confirmPassword"
                      src={icon.hideIcon}
                      onClick={()=>{
                        hideShow(intl.formatMessage({ id: 'confirmPassword' }),"confirmPassword")
                      }}
                    /></i>
            </label>
            <div className="main_button_rest_password">
              <button
                className="btn_main_reset_password btn_sign_in_reset_password"
                type="submit"
              > 
                {isLoading ? "Processing..." : "Reset Password" }
               
                {/* {isLoading ? <LoadingSpinner className="small" varient="white" position="center" /> : "Reset Password" } */}
              </button>
            </div>
            <div className="bottom_fotter">
              <a className={("font_main_color forget resend")} onClick={resendConfirmationCode}>
              { timerOn ? `Resend OTP in: ${remainingSecond} seconds` : "Resend OTP" }
            </a>
            <br/>
            <br/>
            <a className="App-link" onClick={back}>
              Sign in
            </a>
          </div>
          </form>
        </div>
        </div>
      
    </div>
  );
}
export default ChildResetPassword;
